import { PageTitle } from "@components/PageTitle"
import { ProspectForm } from "@components/ProspectNew/ProspectForm/ProspectForm"
import { useNavigate } from "react-router-dom"

export const ProspectCreate = () => {
  const navigate = useNavigate()
  return (
    <div className="tw:flex tw:flex-col tw:gap-4">
      <PageTitle title="Create Prospect" />
      <ProspectForm
        onSuccess={(prospect) => {
          navigate(`/prospect/${prospect.prospect_guid}`)
        }}
      />
    </div>
  )
}
